import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class MandatesService {
  sendInvoiceMandateForm(mandateSubjectType, mandateSubjectId, email) {
    return securedAxiosInstance.post("/mandates", toSnakeCase({ mandateSubjectType, mandateSubjectId, email }));
  }

  sendNewLink(mandateId) {
    return securedAxiosInstance.post(`/mandates/${mandateId}/send_new_link`);
  }

  cancel(mandateId) {
    return securedAxiosInstance.delete(`/mandates/${mandateId}`);
  }
}

export default new MandatesService();
